import { render, staticRenderFns } from "./asesoria.vue?vue&type=template&id=7ecc37b7&"
import script from "./asesoria.vue?vue&type=script&lang=js&"
export * from "./asesoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports